/* ============================================================
   CRO cart enhancements — Limn Clothing (theme: SG | CRO | 22/06)
   Keeps the free-shipping progress bar in sync on every cart change.
   Theme = Turbo (jQuery 3.x). There is NO cart event in this theme;
   all cart I/O goes through jQuery $.ajax, so we hook ajaxComplete.
   This file modifies no core theme files.
   ============================================================ */
(function () {
  var $ = window.jQuery;
  if (!$) { return; }

  /* Self-contained Shopify money formatter (so we don't depend on
     Shopify.formatMoney being present on every template). */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
      default: value = num(2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  function updateBars(cart) {
    $('.js-cart_free_shipping').each(function () {
      var $bar = $(this);
      var threshold = parseInt($bar.attr('data-threshold'), 10) || 0;
      if (threshold <= 0) { return; }
      var total = cart.total_price || 0;
      var pct = Math.min(100, (total / threshold) * 100);
      var remaining = Math.max(0, threshold - total);
      $bar.find('.js-cro-ship-fill').css('width', pct + '%');
      var $msg = $bar.find('.js-cro-ship-msg');
      if (remaining <= 0) {
        $bar.addClass('cro-ship--unlocked');
        $msg.html($bar.attr('data-unlocked-text') || '');
      } else {
        $bar.removeClass('cro-ship--unlocked');
        var fmt = $bar.attr('data-money-format') || '${{amount}}';
        var tmpl = $bar.attr('data-progress-text') || '';
        $msg.html(tmpl.replace('__CRO_AMT__', '<strong>' + formatMoney(remaining, fmt) + '</strong>'));
      }
    });
  }

  function refresh() {
    if (!$('.js-cart_free_shipping').length) { return; }
    /* Native fetch (not $.ajax) so this read does NOT re-trigger
       jQuery's global ajaxComplete handler below -> avoids a loop. */
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateBars)
      .catch(function () {});
  }

  /* Only cart MUTATIONS trigger a refresh. The pattern must never match a
     plain `/cart.js` READ: a read that re-triggers the refresh is how this
     turns into an unbounded request loop (see the badge handler below). */
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;

  $(document).ajaxComplete(function (e, xhr, opts) {
    if (opts && opts.url && CART_MUTATION.test(opts.url)) {
      refresh();
    }
  });

  $(function () { refresh(); });
})();

/* ============================================================
   CRO cart drawer — AJAX-driven helpers (count badge / discount /
   upsell carousel). Open/close/hover-blocking logic moved to the
   capture-phase IIFE below this block.
   ============================================================ */
(function ($) {
  if (!window.jQuery) { return; }

  /* ---- Live count badge update (drawer head + subtotal badge) ----
     This was an unbounded request loop. The old guard matched `/cart.js`
     itself and then answered with `$.getJSON('/cart.js')` — a jQuery request,
     which fires ajaxComplete again, which matches again… Every single cart
     interaction span­ned dozens of /cart.js GETs and raced the drawer
     re-render. Fixed on both counts: only mutations trigger it, and the read
     uses native fetch, which does not fire jQuery's global ajax hooks. */
  $(document).on('ajaxComplete', function (_e, _xhr, settings) {
    if (!settings || !/\/cart\/(add|change|update|clear)(\.js)?/.test(settings.url || '')) { return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $('.js-cro-cart-count, .js-cro-cart-badge').text(cart.item_count);
        $('.cro-cart__head-noun').text(cart.item_count === 1 ? 'item' : 'items');
      })
      .catch(function () {});
  });

  /* ---- Discount-code apply (Shopify /discount/CODE pattern) ---- */
  $(document).on('click', '.js-cro-discount-apply', function (e) {
    e.preventDefault();
    var $input = $('.js-cro-discount-input');
    var code = ($input.val() || '').trim();
    var $msg = $('.js-cro-discount-msg').prop('hidden', false);
    if (!code) {
      $msg.attr('data-state', 'error').text('Enter a code');
      return;
    }
    $msg.attr('data-state', '').text('Applying…');

    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET', credentials: 'same-origin', redirect: 'follow'
    })
    .then(function () {
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _cro_discount_touch: Date.now().toString() } })
      });
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (typeof window.refreshCart === 'function') { window.refreshCart(cart); }
      else { $(document).trigger('ajaxComplete', [null, { url: '/cart/update.js' }]); }
      if (cart.total_discount > 0) {
        $msg.attr('data-state', 'success').text('Code applied');
      } else {
        $msg.attr('data-state', 'error').text('Code not valid for this cart');
      }
    })
    .catch(function () {
      $msg.attr('data-state', 'error').text('Could not apply code');
    });
  });

  /* ---- Upsell single-card carousel ----
     snippets/cro-cart-upsell.liquid renders N .cro-upsell__item rows; wrap them
     in a .cro-upsell__track + add prev/next arrows when 2+. */
  function buildUpsellCarousel() {
    var $up = $('.cro-upsell, .js-cart_upsell').first();
    if (!$up.length || $up.data('cro-carousel-init')) { return; }
    var $items = $up.find('.cro-upsell__item');
    if ($items.length < 2) { $up.data('cro-carousel-init', true); return; }
    $up.data('cro-carousel-init', true);
    var $track = $('<div class="cro-upsell__track"></div>').append($items);
    var $nav = $(
      '<div class="cro-upsell__nav">' +
        '<button type="button" class="cro-upsell__arrow" data-dir="-1" aria-label="Previous">&lsaquo;</button>' +
        '<button type="button" class="cro-upsell__arrow" data-dir="1" aria-label="Next">&rsaquo;</button>' +
      '</div>'
    );
    var $title = $up.find('.cro-upsell__title');
    if ($title.length) { $title.after($nav); } else { $up.prepend($nav); }
    $up.append($track);
    var idx = 0, max = $items.length - 1;
    function go() {
      var w = $track[0].clientWidth;
      $track[0].scrollTo({ left: idx * w, behavior: 'smooth' });
      $up.find('[data-dir="-1"]').prop('disabled', idx === 0);
      $up.find('[data-dir="1"]').prop('disabled', idx === max);
    }
    $up.on('click', '.cro-upsell__arrow', function () {
      idx = Math.max(0, Math.min(max, idx + Number($(this).data('dir'))));
      go();
    });
    go();
  }
  $(function () { buildUpsellCarousel(); });
})(jQuery);

/* ============================================================
   CRO cart — full control (click-only, hover blocked, body.cro-cart-open
   drives all visibility).

   We previously tried syncing body.cro-cart-open to .cart-container.active_link
   via MutationObserver. The theme also toggles .active_link on HOVER
   (sections.js.liquid:2536-2542), which made the page blur/flash as the
   cursor passed over the cart icon. We also previously called jQuery .off()
   to strip the hover bindings, but timing/rebinding races meant they kept
   re-attaching.

   New strategy:
   1. Capture-phase listeners on document for mouseenter/mouseleave on
      .cart-container/.mini_cart — call stopImmediatePropagation so the
      theme handlers (target-phase) NEVER fire. Hover is structurally dead.
   2. Capture-phase click handler on .mini_cart / .cro-icon--cart — toggles
      body.cro-cart-open (NOT .active_link). preventDefault stops the
      <a href="/cart"> from navigating away on mobile.
   3. Bridge theme .active_link → body.cro-cart-open via MutationObserver
      so the theme's post-add behaviour (it adds .active_link in
      app.js.liquid:791 after AJAX add-to-cart) still opens the drawer.
   4. Close handlers: scrim click, × button, ESC. All sync both states.
   ============================================================ */
(function () {

  function isOpen() { return document.body.classList.contains('cro-cart-open'); }
  function openCart() {
    document.body.classList.add('cro-cart-open');
    var cc = document.querySelector('.cart-container');
    if (cc) { cc.classList.add('active_link'); }
  }
  function closeCart() {
    document.body.classList.remove('cro-cart-open');
    var cc = document.querySelector('.cart-container');
    if (cc) { cc.classList.remove('active_link'); }
  }
  function toggleCart() { if (isOpen()) { closeCart(); } else { openCart(); } }

  /* 1. Block hover-driven behaviour structurally — capture phase fires
        BEFORE any target-phase jQuery handler bound by the theme. */
  var HOVER_EVENTS = ['mouseenter', 'mouseleave', 'mouseover', 'mouseout'];
  HOVER_EVENTS.forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.cart-container, .mini_cart, .cro-icon--cart')) {
        e.stopImmediatePropagation();
      }
    }, true);
  });

  /* 2. Click on cart icon — capture phase so the theme's bound click
        never fires. preventDefault stops anchor navigation on mobile. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var trigger = t && t.closest && t.closest('.mini_cart, .cro-icon--cart');
    if (!trigger) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    toggleCart();
  }, true);

  /* 3. Bridge theme's .active_link → body.cro-cart-open. Theme code paths
        that add .active_link (e.g. post-add in app.js.liquid) will now
        also open the drawer. */
  function bridgeActiveLink() {
    var ccs = document.querySelectorAll('.cart-container');
    if (!ccs.length || typeof MutationObserver !== 'function') { return; }
    var mo = new MutationObserver(function () {
      var cc = document.querySelector('.cart-container');
      if (!cc) { return; }
      var themeOpen = cc.classList.contains('active_link');
      if (themeOpen && !isOpen()) { document.body.classList.add('cro-cart-open'); }
      if (!themeOpen && isOpen()) { document.body.classList.remove('cro-cart-open'); }
    });
    ccs.forEach(function (cc) { mo.observe(cc, { attributes: true, attributeFilter: ['class'] }); });
  }
  if (document.readyState !== 'loading') { bridgeActiveLink(); }
  else { document.addEventListener('DOMContentLoaded', bridgeActiveLink); }

  /* 4. Close handlers — scrim / × / ESC */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest('.js-cro-cart-close') || t.closest('.cro-cart__scrim')) {
      e.preventDefault();
      closeCart();
    }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && isOpen()) { closeCart(); }
  });

  /* Relocate the scrim to <body> so it can cover the viewport (it ships
     as a sibling of .cro-cart inside .cart_content). */
  function relocateScrim() {
    var scrim = document.querySelector('.cro-cart__scrim');
    if (scrim && scrim.parentNode !== document.body) { document.body.appendChild(scrim); }
  }
  if (document.readyState !== 'loading') { relocateScrim(); }
  else { document.addEventListener('DOMContentLoaded', relocateScrim); }
})();
